import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faChevronDown, faBell } from '@fortawesome/free-solid-svg-icons';
import './HeaderDashboard.css';
import Logo from '../assets/img/Logo.png';
import ListingModal from './ListingModal'; // Modal component for listing page
import { logout } from './helper/auth';
import axios from 'axios';
import {axiosInstance} from './helper/axiosConfig';
import { isAdmin, isDoctor } from './helper/authRoles';
import moment from 'moment';
import toast, { Toaster } from 'react-hot-toast';

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();

  // Determine the correct ordinal suffix
  let suffix = 'th';
  if (day === 1 || day === 21 || day === 31) suffix = 'st';
  else if (day === 2 || day === 22) suffix = 'nd';
  else if (day === 3 || day === 23) suffix = 'rd';

  return `${day}${suffix} ${month} `;
};

function HeaderDashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('Prescription'); // Default tab
  const [notifications, setNotifications] = useState([]); // State to store notifications
  const [showNotifications, setShowNotifications] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const generateRandomSeed = () => Math.random().toString(36).substring(2, 15);
  // Retrieve user info from localStorage
  const [userInfo, setUserInfo] = useState({
    name: 'Admin', // Default name
    avatar: `https://api.dicebear.com/6.x/micah/svg?seed=${generateRandomSeed()}`, // Default avatar
  });

  useEffect(() => {
    const storedUserInfo = JSON.parse(localStorage.getItem('user-info'));

    if (storedUserInfo) {
      if (storedUserInfo.doctor) {
        // Use doctor data if available
        const doctorData = storedUserInfo.doctor;
        setUserInfo({
          name: doctorData.full_name || 'Doctor', // Use full_name if available
          avatar: doctorData.profile_pic
            ? `${process.env.REACT_APP_AXIOS_BASE_URL}${doctorData.profile_pic}`
            : `https://api.dicebear.com/6.x/micah/svg?seed=${generateRandomSeed()}`, // Fallback to placeholder if no profile_pic
        });
      } else {
        // Fallback to other fields if no doctor data
        setUserInfo({
          name: (storedUserInfo.name && storedUserInfo.name.trim())|| storedUserInfo.email || 'Admin', // Check name first, then email
          avatar: `https://api.dicebear.com/6.x/micah/svg?seed=${generateRandomSeed()}`, // Default avatar
        });
      }
    }



    // Fetch notifications (example API call)
    const fetchNotifications = async () => {
      try {
        const response = await axiosInstance.get('/api/appoinment-notifications');
        console.log("the data is = ", response.data)
        setNotifications(response.data);
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };

    fetchNotifications();


  }, []);

  const handleSearchFocus = () => {
    setIsModalOpen(true);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setIsModalOpen(true); // Open the modal whenever the tab changes
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleLogout = async () => {
    const token = localStorage.getItem('authToken');
    try {
      await axios.post(`${process.env.REACT_APP_AXIOS_BASE_URL}/auth/logout/`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      localStorage.removeItem('authToken');
      localStorage.removeItem('user-info');
      logout();
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <>
    <header className="dashboard-header">
      {/* Logo Section */}
      <div className="logo">
        <Link to="/dashboard"><img src={Logo} alt="Sneho Health Logo" className="logo-image" /></Link>
      </div>

      {/* Search and Tab Section */}
      <div className="search-container">
        <FontAwesomeIcon icon={faSearch} className="search-icon" />
        <input
          type="text"
          placeholder="Search by Name, ID, Mobile No or filter by"
          className="search-input"
          value={searchTerm}
          onFocus={handleSearchFocus}
          onChange={handleSearchChange}
        />
        <div className="tab-container">
          {['Prescription', 'Medicine', 'Patient'].map((tab) => (
            <button
              key={tab}
              className={`tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => handleTabChange(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* User Info Section */}
      <div className="header-right">
          <>
          <div className="mSearch"><FontAwesomeIcon onClick={toggleSearch}  icon={faSearch} className="search-icon" /></div>
          {/* Notification Icon with Badge */}
          {isDoctor() && (
            <div className="notification-container" onMouseEnter={() => setShowNotifications(true)} onMouseLeave={() => setShowNotifications(false)}>
              <FontAwesomeIcon icon={faBell} className="notification-icon" />
              {notifications.length > 0 && <span className="badge">{notifications.length}</span>}

              {showNotifications && (
                <div className="notification-dropdown">
                  <h4>Upcoming Appointments ({notifications.length})</h4>
                  {notifications.length > 0 ? (
                    notifications.map((notification) => (
                      <Link to={
                        moment(notification.date).isSame(moment().startOf('day'), 'day')
                          ? `/create-prescription?mobile=${notification.patient_number}&name=${notification.patient_name}&appointment=${notification.id}`
                          : '/appoinment-history'
                      }>
                      <div key={notification.id} className={`notification-item ${moment(notification.date).isSame(moment().startOf('day'), 'day') ? 'today' : ''}`}>
                        <span className="patient-name">{notification.patient_name}</span>
                        <span className="appointment-date">{formatDate(notification.date)}
                        <strong>
                        {notification.time ? (
                            (() => {
                              const [hours, minutes, seconds] = notification.time.split(':');
                              const date = new Date();
                              date.setHours(parseInt(hours, 10), parseInt(minutes, 10), parseInt(seconds, 10));
                              return date.toLocaleTimeString('en-US', {
                                hour: '2-digit',
                                minute: '2-digit',
                              });
                            })()
                          ) : (
                            "N/A"
                          )}
                          </strong>
                        </span>
                      </div>
                      </Link>
                    ))
                  ) : (
                    <p>No new notifications</p>
                  )}
                </div>
              )}
            </div>
          )}
        </>
        <div className="user-info">
          <img src={userInfo.avatar} alt="User Avatar" className="avatar" />
          <span className="username">{userInfo.name}</span>
          <div className="user-menu">
            {isDoctor() && (
              <Link to="/profile">Profile</Link>
            )}
            <Link to="/change-password">Change Password</Link>
            <button onClick={handleLogout} className="logout-button btn btn-danger">Log Out</button>
          </div>
          <FontAwesomeIcon icon={faChevronDown} className="picker-icon" />
        </div>
        <Toaster
          position="top-right"
          reverseOrder={true}
        />
      </div>

      {/* Listing Modal */}
      {isModalOpen && (
        <ListingModal
          onClose={() => setIsModalOpen(false)}
          searchTerm={searchTerm}
          activeTab={activeTab}
        />
      )}
    </header>
    <div className={`search-header ${isSearchOpen ? 'active' : ''}`}>
      <div className="search-container">
        <FontAwesomeIcon icon={faSearch} className="search-icon" />
        <input
          type="text"
          placeholder="Search by Name, ID, Mobile No or filter by"
          className="search-input"
          value={searchTerm}
          onFocus={handleSearchFocus}
          onChange={handleSearchChange}
        />
        <div className="tab-container">
          {['Prescription', 'Medicine', 'Patient'].map((tab) => (
            <button
              key={tab}
              className={`tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => handleTabChange(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>
    </div>
    </>
  );
}

export default HeaderDashboard;
